import * as rq from '@tanstack/react-query';

import { deleteRole } from '../queries/__mocked_data__/roles-state';

export namespace DeleteRoleMutation {
  export type Input = {
    id: string;
  };
  export type Output = void;

  function useMutationFn() {
    return async function mutationFn(input: Input) {
      // Add artificial 500ms delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      const success = deleteRole(input.id);

      if (!success) {
        throw new Error(
          `Failed to delete role with id ${input.id} - role may not exist or may have users assigned`,
        );
      }

      return;
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess(_, input) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: ['user-management', 'roles'],
          }),
          queryClient.invalidateQueries({
            queryKey: ['user-management', 'role', input.id],
          }),
        ]);
      },
    });
  }
}
